@use '../../styles/tokens' as *;

.appNav {
  background-color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08), 0 4px 18px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  position: relative;
  transition: all 250ms ease;
  z-index: $zTopNav;
  flex-shrink: 0;
}

@media print {
  .appNav {
    display: none;
  }
}

.content {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 100%;
  padding: 0.8rem 2rem;
  transition: all 250ms ease;
}

.left {
  align-items: center;
  display: flex;
  position: relative;
}

.popoverTarget {
  display: block !important; // overrides a blueprint style that breaks sizing
}

.breadcrumbs {
  display: flex;
  flex: auto;
  font-size: 1.8rem;
  font-weight: 400;
  justify-content: center;
  margin-left: 1.2rem;
  overflow: hidden;

  li {
    align-items: center;
    display: flex;

    &:not(:first-child) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    & > * {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.chevronIcon {
  padding: 0 0.4rem;

  svg:not([fill]) {
    fill: $colorDarkGray;
  }
}

.users {
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.helpMenuPopover,
.onboardingMenuPopover {
  height: 100%;
}

.helpMenu,
.onboardingMenu {
  align-items: center;
  color: $colorPrimary;
  cursor: pointer;
  display: flex;
  height: 100%;
  font-size: $appNavFontSize;
  font-weight: 700;
  margin: 0 $appNavHeadingMargin;
}

.onboardingTaskListContainer {
  padding: 1rem 2rem;

  .onboardingTaskList li {
    padding: 1rem 0;
    display: flex;
    align-items: center;

    .onboardingMenuTaskText {
      margin-left: 1rem;
    }
  }
}

.onboardingTaskList {}
.onboardingMenuTaskText {}

.onboardingMenuActions {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid $colorDarkGray;
  font-size: 1.2rem;

  li {
    padding: 0.4rem 0;
  }
}

.buttonIconSpacing {
  margin-left: $buttonIconMargin;
}

.currentUser {
  align-items: center;
  color: $colorPrimary;
  cursor: pointer;
  display: flex;
  font-size: $appNavFontSize;
  font-weight: 700;
  margin-left: $appNavHeadingMargin;

  &:hover {
    span {
      transform: translateY(0.1rem);
      transition: transform 0.2s ease;
    }
  }
}

.currentUserName {
  margin-left: 0.8rem;
  max-width: 20rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.realtimeUsers {
  align-items: center;
  display: flex;
  flex-direction: row-reverse;

  > :first-child {
    padding-right: 1.2rem;
    border-right: 1px solid $colorLightGray;
  }

  img {
    box-shadow: 2px 0 0 white;
  }

  span {
    display: block;
  }
}

.userEnter {
  opacity: 0;
  transform: translateY(3.2rem);
}

.userEnterActive {
  opacity: 1;
  transform: translateY(0);
  transition: all 250ms ease;
}

.userLeave {
  opacity: 1;
  transform: translateY(0);
}

.userLeaveActive {
  opacity: 0;
  transform: translateY(50%);
  transition: all 250ms ease;
}

.toasterContainer {
  height: 0;
  position: relative;
  top: -10px;
  width: 100%;
}

.toaster {
  // Overrides the position fixed so that we're relative to the placement
  // of toasterContainer
  position: absolute;
}

.dateChangeToast {
  background-color: rgba(255, 255, 255, 0.9);
  min-width: 0;

  // Hides the element after the button, which is the close box that we don't
  // want to appear.
  :global(.bp5-toast-message + *) {
    display: none;
  }
}

.productTier {
  // Makes the (i) icon align to the bottom of the div
  align-items: flex-end;

  // Prevents the bp5-menu-item CSS from making this look clickable
  &:hover {
    cursor: unset;
    background-color: unset;
  }
}

.productTierLabel {
  font-size: 1.2rem;
  color: $colorDarkGray;
}

.productTierName {
  font-weight: bold;
}
